export const fahrradsucheAGPSSTabName = "#tabs_suche";
export const fahrradsucheWebsitePathName = "haendlersuche";
